export default "__VITE_PUBLIC_ASSET__bcb41214__"